import React, { useEffect, useState, useCallback, useRef } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Form, Radio, Checkbox, Icon, Dropdown } from "semantic-ui-react";
import ReactSelect from 'react-select';
import {
  Container,
  Field,
  InlineField,
  CheckBoxField,
  Title,
  Input,
  InputFile,
  Select,
  Label,
  Textarea,
  Button,
} from "./styled";
import swal from "sweetalert";
import NewTextEditor from "../../../../components/Admin/NewTextEditor";
import { isAuthAdmin } from "../../../../services/auth";
import { systemLogs } from "../../../../services/system_logs";

const UpdateCurso = ({ idCurso, history }) => {
  const [tipo, setTipo] = useState("0");
  const [idColaboradores, setIdColaboradores] = useState([]);
  const [titulo, setTitulo] = useState("");
  const [nomeRD, setNomeRD] = useState("");
  const [contatoEmail, setContatoEmail] = useState("");
  const [valor, setValor] = useState(0);
  const [valorFicticio, setValorFicticio] = useState(0);
  const [vagas, setVagas] = useState(0);
  const [ativo, setAtivo] = useState(0);
  const [numeroVideos, setNumeroVideos] = useState(0);
  const [cargaHoraria, setCargaHoraria] = useState(0);
  const [obs, setObs] = useState("");
  const [urlAmigavel, setUrlAmigavel] = useState("");
  const [lang, setLang] = useState("pt-BR");
  const [area, setArea] = useState(0);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [areas, setAreas] = useState([]);
  const [treinamento, setTreinamento] = useState();
  const [consultores, setConsultores] = useState([]);
  /*   const [cardsPacotes, setCardsPacotes] = useState([]);
   */ const [idPacotes, setIdPacotes] = useState([]);
  const [espera, setEspera] = useState(false);
  const [materialImpresso, setMaterialImpresso] = useState(false);
  const [certificadoImpresso, setCertificadoImpresso] = useState(false);
  const [listarCurso, setListarCurso] = useState(false);
  const [disponivel, setDisponivel] = useState(false);
  const certificadoDescription = useRef("");
  const [
    certificadoDescriptionState,
    setCertificadoDescriptionState,
  ] = useState(null);
  const [novo, setNovo] = useState(0);
  const [nivelCurso, setNivelCurso] = useState("");
  const [allIn, setAllIn] = useState(false);
  const [urlRedirect, setUrlRedirect] = useState("");
  const [hasUrlRedirect, setHasUrlRedirect] = useState(false);
  const [imagemComboMobile, setImagemComboMobile] = useState("");
  const [imagemDesktop, setImagemDesktop] = useState("");
  const [ordem, setOrdem] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const [dates, setDates] = useState([
    {
      data: "",
      hora_inicial: "",
      hora_final: "",
    },
  ]);

  const [images, setImages] = useState({
    capa: "",
    detalhamentoCurso: "",
    imagemFundoCabecario: "",
  });

  const yesOrNoOptions = [
    { id: 1, descricao: "Sim" },
    { id: 0, descricao: "Não" },
  ];

  const activeOptions = [
    { id: "S", descricao: "Sim" },
    { id: "N", descricao: "Não" },
  ];

  const nivelCursoOptions = [
    { id: 1, descricao: "Básico ao avançado" },
    { id: 2, descricao: "Iniciantes" },
    { id: 3, descricao: "Intermediário" },
    { id: 4, descricao: "Avançado" },
  ];

  const languages = [
    { id: 0, descricao: "pt-BR" },
    { id: 1, descricao: "en-US" },
  ];

  useEffect(() => {
    loadAuth();

    const getOptions = async () => {
      setIsLoading(true);

      try {
        const [{ data: areas }, { data: consultores }, { data: curso }, { data: categories }] = await Promise.all([
          api.get("/area-descricao"),
          api.get("/consultor?all=1"),
          api.get(`/cursolist/${idCurso}`),
          api.get(`/admin/categories`),
        ])

        /*         const cardsPacote = (await api.get("/card-combos")).data;
         */
        let logs = {
          local: "curso/update",
          texto: `listou o curso de id=${idCurso}`,
        };

        api.post("system_logs", { acao: JSON.stringify(logs) });
        const idCobaradores = curso.id_colaborador
          .split(",")
          .map((id) => Number(id));
        const pacotes = curso.combos_digital
          ? curso?.combos_digital?.split(",").map((id) => Number(id))
          : null;

        setSelectedCategories(curso.categories);
        setCategories(categories);
        setTipo(curso.tipo);
        setArea(curso.area_corporativo);
        setAtivo(curso.ativo);
        setCargaHoraria(curso.carga_horaria);
        setContatoEmail(curso.contato_email);
        setTitulo(curso.curso);
        setNomeRD(curso.nome_rd);
        setListarCurso(curso.listar == 1);
        setCertificadoImpresso(curso.hascertificate == 1);
        setMaterialImpresso(curso.hasmaterial == 1);
        setEspera(curso.espera == 1);
        setIdColaboradores(idCobaradores);
        setCertificadoDescriptionState(curso.description_certificado);
        setLang(curso.lang);
        setNivelCurso(curso.nivel || "");
        setNumeroVideos(curso.numero_videos);
        setObs(curso.obs);
        setUrlAmigavel(curso.url_amigavel);
        setVagas(curso.vagas);
        setValor(curso.valor);
        setValorFicticio(curso.valor_ficticio);
        setUrlRedirect(!!curso.url_redirect ? curso.url_redirect : "");
        setDates(curso.datas);
        setNovo(curso.novo === 0 ? 0 : 1);
        setAllIn(curso.valorAllIn !== 0);
        setHasUrlRedirect(!!curso.url_redirect);
        setIdPacotes(pacotes);
        setDisponivel(curso.is_valid_to_watch);

        setAreas(areas);
        setTreinamento(curso?.treinamento);
        setConsultores(consultores);
        setOrdem(curso.ordem);
        /*         setCardsPacotes(cardsPacote);
         */
      } catch (err) {
        swal(
          "Curso Inválido",
          `Ops! Parece que esse curso não existe. Error: ${err}`,
          "error"
        );
      } finally {
        setIsLoading(false);
      }
    };

    getOptions();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const uploadContent = useCallback(
    async (file, folder) => {
      if (!images[file]) {
        return;
      }

      const formData = new FormData();

      formData.append("file", images[file]);
      formData.append("folder", folder);
      formData.append("url", urlAmigavel);

      await api.post("/curso/upload-content", formData).catch(() => {
        throw new Error("Erro ao enviar o arquivo. Verifique se o formato é adequado (imagens: .jpg/.png, slides: .pdf)");
      });
    },
    [images, urlAmigavel]
  );

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();

    if(!selectedCategories || selectedCategories?.length === 0) {
      swal('Erro', 'É necessário selecionar pelo menos uma categoria', 'error');
      return;
    }

    setIsSaving(true);

    const payload = {
      tipo: tipo,
      id_treinamento: treinamento?.id,
      id_colaborador: idColaboradores.join(","),
      area_corporativo: area || 0,
      curso: titulo,
      contato_email: contatoEmail,
      valor: valor,
      valorAllIn: allIn ? valor : 0,
      valor_ficticio: (valorFicticio || 0).toString(),
      vagas: vagas,
      ativo: ativo,
      is_valid_to_watch: disponivel,
      numero_videos: numeroVideos,
      carga_horaria: cargaHoraria,
      obs: obs,
      url_amigavel: urlAmigavel,
      url_redirect: urlRedirect,
      lang: lang,
      listar: listarCurso ? 1 : 0,
      description_certificado: certificadoDescription.current,
      hascertificate: certificadoImpresso ? 1 : 0,
      hasmaterial: materialImpresso ? 1 : 0,
      novo: novo,
      nivel: nivelCurso,
      espera: espera ? 1 : 0,
      nome_rd: nomeRD,
      dates: tipo === 6 ? dates.filter((date) => !!date.data) : [],
      imagem_mobile: imagemComboMobile,
      imagem_web: imagemDesktop,
      ordem: ordem,
      combos_digital: idPacotes ? idPacotes.join(",") : "",
      category_ids: selectedCategories.map(category => category.id)
    };

    try {
      await api.put(`/admin/curso/${idCurso}`, payload);

      await uploadContent("capa", "cursos/new_dash");
      await uploadContent("detalhamentoCurso", "cursos/slides");
      await uploadContent("imagemFundoCabecario", "cursos/covers");

      await systemLogs("curso/update", `editou o curso de id=${idCurso}`);

      swal(
        "Curso atualizado",
        "As alterações foram salvas com sucesso!",
        "success"
      );
    } catch (err) {
      swal(
        "Erro ao editar curso",
        err?.message || "Por favor, verifique se todos os campos estão preenchidos corretamente",
        "error"
      );
    } finally {
      setIsSaving(false);
    }
  }, [
    dates,
    images,
    tipo,
    idColaboradores,
    area,
    titulo,
    contatoEmail,
    valor,
    disponivel,
    valorFicticio,
    allIn,
    vagas,
    ativo,
    numeroVideos,
    cargaHoraria,
    obs,
    urlAmigavel,
    urlRedirect,
    lang,
    listarCurso,
    certificadoImpresso,
    materialImpresso,
    novo,
    nivelCurso,
    espera,
    ordem,
    uploadContent,
    idPacotes,
    selectedCategories
  ]);

  const changeDate = useCallback(
    (e, index) => {
      dates[index][e.target.name] = e.target.value;
      setDates([...dates]);
    },
    [dates]
  );

  const addDate = useCallback(() => {
    dates.push({
      data: "",
      hora_inicial: "",
      hora_final: "",
    });
    setDates([...dates]);
  }, [dates]);

  const handleChangeCategories = (categories) => {
    setSelectedCategories(categories);
  }

  return (
    <Container>
      <Title>Editar Curso #{idCurso}</Title>

      <Form>
        <CheckBoxField>
          <Label>Tipo do curso</Label>
          <Radio
            label="Online"
            name="radioGroup"
            value={3}
            checked={tipo == 3}
            onChange={() => setTipo(3)}
          />

          <Radio
            label="Ao Vivo"
            name="radioGroup"
            value={6}
            checked={tipo == 6}
            onChange={() => setTipo(6)}
          />
        </CheckBoxField>

        <Field>
          <Label>Nome do curso</Label>
          <Input
            name="tituloCurso"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
          />
        </Field>

        <Field>
          <Label>Categorias *</Label>
          <ReactSelect
            isMulti
            isLoading={isLoading}
            loadingMessage={() => "Buscando categorias"}
            noOptionsMessage={({ inputValue }) => `Nenhuma categoria encontrada com "${inputValue}"`}
            placeholder="Selecione uma categoria"
            options={categories}
            value={selectedCategories}
            getOptionValue={category => category.id}
            getOptionLabel={category => category.name}
            onChange={(selectedCategories) => handleChangeCategories(selectedCategories)}
          />
        </Field>

        <Field>
          <Label>Ordem do curso</Label>
          <Input
            type={"number"}
            name="ordemCurso"
            onChange={(e) => {
              setOrdem(e.target.value);
            }}
            value={ordem}
          />
        </Field>

        <InlineField>
          <Field>
            <Label>Área Corporativo</Label>
            <Select
              name="areaCurso"
              value={area}
              onChange={(e) => setArea(e.target.value)}
            >
              <option value={0}>Nenhuma área em específica</option>

              {areas.map((area) => (
                <option value={area?.areacorp.id}>
                  {area?.areacorp.nome_tab}
                </option>
              ))}
            </Select>
          </Field>

          <Field>
            <Label>Treinamento</Label>
            <Select name="treinamento" value={treinamento?.id} disabled>
              {[treinamento].map((treinamento) => (
                <option value={treinamento?.id}>{treinamento?.nome}</option>
              ))}
            </Select>
          </Field>
        </InlineField>

        <Field>
          <Label>Nível do curso</Label>
          <Select
            name="nivelCurso"
            value={nivelCurso}
            onChange={(e) => setNivelCurso(e.target.value)}
          >
            <option value="" hidden>
              Selecione
            </option>

            {nivelCursoOptions.map((nivel) => (
              <option value={nivel.descricao}>{nivel.descricao}</option>
            ))}
          </Select>
        </Field>

        <Field>
          <Label>Está em lista de espera ?:</Label>
          <Checkbox
            style={{
              marginTop: "32px",
              marginLeft: "8px",
            }}
            name="espera"
            checked={espera}
            onChange={() => setEspera(!espera)}
          />
        </Field>

        <Field>
          <Label>Nome para o RD:</Label>
          <Input
            name="nomeRD"
            value={nomeRD}
            onChange={(e) => setNomeRD(e.target.value)}
          />
        </Field>

        {/* <Field>
          <Label>Esse curso fará parte do All In ?:</Label>
          <Checkbox
            style={{
              marginTop: "32px",
              marginLeft: "8px",
            }}
            name="allIn"
            checked={allIn}
            onChange={() => setAllIn(!allIn)}
          />
        </Field> */}

        <Field>
          <Label>Url do Curso</Label>

          <Input
            name="url-amigavel"
            value={urlAmigavel}
            onChange={(e) => setUrlAmigavel(e.target.value)}
          />
        </Field>

        <Field>
          <Label>Observação</Label>
          <Textarea
            name="obs"
            cols="10"
            rows="10"
            value={obs}
            onChange={(e) => setObs(e.target.value)}
          ></Textarea>
        </Field>

        {tipo === 6 && (
          <div style={{ marginTop: "32px", marginBottom: "32px" }}>
            <div style={{ marginBottom: "16px" }}>
              {dates.map((date, index) => (
                <div style={{ display: "flex", marginBottom: "8px" }}>
                  <InlineField style={{ marginRight: "16px" }}>
                    <Label style={{ marginRight: "16px" }}>
                      Data{index + 1}:{" "}
                    </Label>
                    <input
                      name="data"
                      type="date"
                      value={date.data}
                      onChange={(e) => changeDate(e, index)}
                    />
                  </InlineField>

                  <InlineField style={{ marginRight: "16px" }}>
                    <Label style={{ marginRight: "16px" }}>
                      Hora Inicial:{" "}
                    </Label>
                    <input
                      name="hora_inicial"
                      type="time"
                      value={date.hora_inicial}
                      onChange={(e) => changeDate(e, index)}
                    />
                  </InlineField>

                  <InlineField>
                    <Label style={{ marginRight: "16px" }}>Hora Final: </Label>
                    <input
                      name="hora_final"
                      type="time"
                      value={date.hora_final}
                      onChange={(e) => changeDate(e, index)}
                    />
                  </InlineField>
                </div>
              ))}
            </div>

            <Button width="160px" onClick={() => addDate()}>
              <Icon name="plus" /> Adicionar Data
            </Button>
          </div>
        )}

        <Field>
          <Label>Consultor</Label>
          <Dropdown
            name="consultor"
            search
            placeholder="Consultor"
            fluid
            selection
            multiple
            value={idColaboradores}
            options={consultores.map((consultor) => ({
              id: consultor.id,
              value: consultor.id,
              text: consultor.nome,
            }))}
            onChange={(e, { value }) => setIdColaboradores(value)}
          />
        </Field>

        <Field>
          <Label>E-mail de contato</Label>
          <Input
            name="emailContato"
            value={contatoEmail}
            onChange={(e) => setContatoEmail(e.target.value)}
          />
        </Field>

        <Field>
          <Label>Valor do curso</Label>
          <Input
            name="valorCurso"
            value={valor}
            onChange={(e) => setValor(e.target.value)}
          />
        </Field>

        <Field>
          <Label>Valor Fictício</Label>
          <Input
            name="valorFicticio"
            value={valorFicticio}
            onChange={(e) => setValorFicticio(e.target.value)}
          />
        </Field>

        <Field>
          <Label>Numero de Vagas</Label>
          <Input
            name="vagasCurso"
            value={vagas}
            onChange={(e) => setVagas(e.target.value)}
          />
        </Field>

        <Field>
          <Label>Carga horária</Label>
          <Input
            name="cargaHoraria"
            value={cargaHoraria}
            onChange={(e) => setCargaHoraria(e.target.value)}
          />
        </Field>

        <Field>
          <Label>Número de vídeos</Label>
          <Input
            name="quantidadeVideos"
            value={numeroVideos}
            onChange={(e) => setNumeroVideos(e.target.value)}
          />
        </Field>

        <Title>Meta Tag</Title>

        <Field>
          <Label>Idioma do curso</Label>
          <Select
            name="idiomaCurso"
            value={lang}
            onChange={(e) => setLang(e.target.value)}
          >
            {languages.map((opcao) => (
              <option value={opcao.descricao}>{opcao.descricao}</option>
            ))}
          </Select>
        </Field>

        <Field>
          <Label>Capa do Curso</Label>
          <InputFile
            name="capa"
            type="file"
            onChange={(e) => {
              const capa = e.target.files[0];
              setImages({ ...images, capa });
            }}
          />
        </Field>

        <Field>
          <Label>Detalhamento do Curso</Label>
          <InputFile
            name="detalhamentoCurso"
            type="file"
            onChange={(e) => {
              const detalhamentoCurso = e.target.files[0];
              setImages({ ...images, detalhamentoCurso });
            }}
          />
        </Field>

        <Field>
          <Label>Imagem de Fundo do Cabeçário</Label>
          <InputFile
            name="imagemFundoCabecario"
            type="file"
            onChange={(e) => {
              const imagemFundoCabecario = e.target.files[0];
              setImages({ ...images, imagemFundoCabecario });
            }}
          />
        </Field>

        <Field>
          <Label>Imagem para combo (Desktop)</Label>
          <InputFile
            name="imagemDesktop"
            type="file"
            onChange={(e) => {
              const imagemDesktop = e.target.files[0];
              setImages({ ...images, imagemDesktop });
            }}
          />

          <Label color={"#3366ff"}>
            Por favor, insira a imagem no formato
            <Label color={"#ff0000"}> .png </Label>
          </Label>

          <br />

          <Checkbox
            style={{
              marginTop: "10px",
            }}
            name="removerImagem"
            label="Remover Imagem do combo (Desktop)"
            onChange={() => this.toggle("imagemDesktop")}
          />
        </Field>

        <Field>
          <Label>Imagem para combo (Mobile)</Label>
          <InputFile
            name="imagemComboMobile"
            type="file"
            onChange={(e) => {
              const imagemComboMobile = e.target.files[0];
              setImages({ ...images, imagemComboMobile });
            }}
          />

          <Label color={"#3366ff"}>
            Por favor, insira a imagem no formato
            <Label color={"#ff0000"}> .png </Label>
          </Label>

          <br />

          <Checkbox
            style={{
              marginTop: "10px",
            }}
            name="removerImagem"
            label="Remover Imagem do combo (mobile)"
            onChange={() => this.toggle("imagemComboMobile")}
          />
        </Field>

        <Field>
          <Label>Novo</Label>
          <Select
            name="novo"
            value={novo}
            onChange={(e) => setNovo(e.target.value)}
          >
            {yesOrNoOptions.map((opcao) => (
              <option value={opcao.id}>{opcao.descricao}</option>
            ))}
          </Select>
        </Field>

        <Field>
          <Label>Nova URL ?:</Label>
          <Checkbox
            style={{
              marginTop: "32px",
              marginLeft: "8px",
            }}
            name="hasUrlRedirect"
            checked={hasUrlRedirect}
            onChange={() => setHasUrlRedirect(!hasUrlRedirect)}
          />
          {hasUrlRedirect && (
            <Input
              name="novaURL"
              value={urlRedirect}
              onChange={(e) => setUrlRedirect(e.target.value)}
            />
          )}
        </Field>

        <Field>
          <Checkbox
            name="certificadoImpresso"
            checked={certificadoImpresso}
            label="Emitir certificado ?"
            onChange={() => setCertificadoImpresso(!certificadoImpresso)}
          />
        </Field>

        <Field>
          <Label>Descrição do certificado</Label>
          <NewTextEditor
            haveFullscreen
            default={certificadoDescriptionState}
            text={certificadoDescription}
          />
        </Field>

        <Field>
          <Checkbox
            name="materialImpresso"
            checked={materialImpresso}
            label="Tem Material para Imprimir ?"
            onChange={() => setMaterialImpresso(!materialImpresso)}
          />
        </Field>

        <Field>
          <Checkbox
            name="listarCurso"
            checked={listarCurso}
            label="Listar curso:"
            onChange={() => setListarCurso(!listarCurso)}
          />
        </Field>
        <Field>
          <Checkbox
            name="cursoDisponivel"
            checked={disponivel}
            label="Curso disponível para assistir:"
            onChange={() => setDisponivel(!disponivel)}
          />
        </Field>

        <Field>
          <Label>Ativo</Label>
          <Select
            name="ativo"
            value={ativo}
            onChange={(e) => setAtivo(e.target.value)}
          >
            {activeOptions.map((opcao) => (
              <option value={opcao.id}>{opcao.descricao}</option>
            ))}
          </Select>
        </Field>

        <Field>
          {/* <Label>
            Pacotes oferecidos (Selecione na ordem em que deverão aparecer na
            página de vendas)
          </Label> */}
          {/* <Dropdown
            name="pacotes"
            search
            placeholder="Pacotes oferecidos"
            fluid
            selection
            multiple
            value={idPacotes}
            options={cardsPacotes.map((card) => ({
              id: card.id,
              value: card.id,
              text: card.nome,
            }))}
            onChange={(e, { value }) => setIdPacotes(value)}
          /> */}
        </Field>

        <Button type="submit" onClick={handleSubmit} disabled={isSaving}>
          <Icon name={isSaving ? "spinner" : "save"} loading={isSaving} />
          {isSaving ? "Salvando..." : "Salvar"}
        </Button>
      </Form>
    </Container>
  );
};

export default UpdateCurso;
